enum ButtonEnum {
  PRIMARY = 'PRIMARY',
  DANGER = 'DANGER',
  TRANSPARENT = 'TRANSPARENT',
  NOTIFICATION = 'NOTIFICATION',
  GREY_LIGHT = 'GREY_LIGHT',
}

export default ButtonEnum;
